import { QueryClientProvider } from 'react-query';
import type { GetProps } from '@types';
import { queryClient } from '@queryClient';
import { VIP_URL } from '@constants';
import addComponent from '@utils/addComponent';
import { showConfirmModal } from '@components/ConfirmModal';
import { $isVip } from '@stores/memberStores';
import { sendSuccess, sendWarning } from '@components/Noti';
import { $categoryMap } from '@stores/dataStores';
import { ScenesCopyModal } from './ScenesCopyModal';

type Params = Omit<
  GetProps<typeof ScenesCopyModal>,
  'onRequestClose' | 'onComplete'
>;

export const showScenesCopyModal = async (
  params: Params = { level: '作品' }
) => {
  if (params.level === '一级分组' && params.categoryId !== undefined) {
    const map = $categoryMap.getState();
    const item = map.get(params.categoryId);
    if (!item) return;
    let hasChildScenes = !!item.sceneIds.length;
    const subIds = item.categoryIds;
    for (let i = 0; i < subIds.length; i++) {
      const subItem = map.get(subIds[i]);
      if (subItem?.sceneIds.length) {
        hasChildScenes = true;
        break;
      }
    }
    if (!hasChildScenes) {
      sendWarning('分组下无任何场景时无法复制');
      return;
    }
  }

  if (params.level === '二级分组' && params.subCategoryId !== undefined) {
    const map = $categoryMap.getState();
    const item = map.get(params.subCategoryId);
    if (!item?.sceneIds.length) {
      sendWarning('分组下无任何场景时无法复制');
      return;
    }
  }

  const isVip = $isVip.getState();
  if (!isVip) {
    const { confirmed } = await showConfirmModal({
      title: '温馨提示',
      content: (
        <div className="flex flex-col items-center">
          <div className="mb-10 text-xl">升级个人专业版/企业版后即可使用</div>
          <div>
            该功能支持将当前作品中的全部或部分场景复制到其他作品，实现作品合并的功能效果
          </div>
        </div>
      ),
      buttonText: '去升级',
    });
    if (confirmed) {
      window.open(VIP_URL, '_blank');
    }
    return;
  }

  return new Promise<{ success?: boolean }>((resolve) => {
    addComponent((remove) => {
      return (
        <QueryClientProvider client={queryClient}>
          <ScenesCopyModal
            {...params}
            onComplete={() => {
              sendSuccess('复制成功');
              remove();
            }}
            onRequestClose={() => {
              resolve({});
              remove();
            }}
          />
        </QueryClientProvider>
      );
    });
  });
};
